import { OrganizationFeatures } from '@trello/product-features';
import { isEnterpriseOrg, isStandardOrg } from './features';

export const getPaidStatus = (
  premiumFeatures: string[],
  products: number[],
) => {
  return isEnterpriseOrg(premiumFeatures)
    ? 'enterprise'
    : isStandardOrg(products)
    ? 'standard'
    : OrganizationFeatures.hasProduct(products[0]) // need to do BC check after Standard, because this check would return true for a Standard org too
    ? 'bc'
    : 'free';
};
